angular.module('invoice')
    .controller('InvoiceHistoryController', function (data, $uibModalInstance, Invoice) {
        this.$onInit = () => {
            Invoice.history({id: data}).$promise.then(items => this.items = items)
        }
        this.close = () => $uibModalInstance.dismiss()
    })
